export default __webpack_public_path__ + "static/popup-d-931fe4f48ef1b0f03073b0def384a48c.jpg";